@for (chat of chats(); track chat.ref.chatId) {
    <button
        mat-menu-item
        class="thread thread-item group"
        [class.active]="currentChatRef().chatId === chat.ref.chatId"
        [class.has-error]="chat.hasFailedResponse"
        (click)="onSelect(chat.ref)"
        [attr.aria-current]="
            currentChatRef().chatId === chat.ref.chatId ? 'true' : null
        "
    >
        <span
            qpxCell
            variant="md"
            class="line-clamp-2 min-w-0 break-words text-ellipsis underline-offset-2 group-hover:underline group-focus-within:underline"
        >
            {{ chat.title }}
        </span>

        <span class="metadata">
            <qpx-metadata
                icon="lucideClock3"
                label="Last updated"
                [value]="chat.timestamp | qpxRelativeDate"
                [trailingIcon]="
                    chat.hasFailedResponse ? 'lucideCircleAlert' : undefined
                "
                trailingIconContext="destructive"
                trailingIconAriaLabel="Response failed"
                trailingIconLabel="Response failed"
            />

            <qpx-metadata
                icon="lucideBuilding2"
                label="Scope"
                [value]="
                    chat.scope.kind === 'building'
                        ? scopeBuildingName(chat)
                        : 'All buildings'
                "
            />
        </span>
    </button>
} @empty {
    <div class="state">
        <qpx-empty-state
            heading="No chat history"
            visualSize="hero"
            [image]="emptyStateImage"
        >
            <ng-container description>
                Conversations appear here after you send your first message.
            </ng-container>
        </qpx-empty-state>
    </div>
}
